import React from 'react';

interface FocusLinesProps {
  enabled: boolean;
  centerPercent: number;
  heightPercent: number;
  thickness: number;
  opacity: number;
}

export const FocusLines: React.FC<FocusLinesProps> = ({
  enabled,
  centerPercent,
  heightPercent,
  thickness,
  opacity,
}) => {
  if (!enabled || opacity <= 0) return null;

  const topPercent = Math.max(0, centerPercent - heightPercent / 2);
  const bottomPercent = Math.min(100, centerPercent + heightPercent / 2);

  return (
    <>
      <div
        className="absolute left-0 right-0 pointer-events-none z-20 border-white"
        style={{
          top: `${topPercent}%`,
          borderTopWidth: `${thickness}px`,
          opacity,
        }}
        aria-hidden="true"
      />
      <div
        className="absolute left-0 right-0 pointer-events-none z-20 border-white"
        style={{
          top: `${bottomPercent}%`,
          borderTopWidth: `${thickness}px`,
          opacity,
        }}
        aria-hidden="true"
      />
    </>
  );
};
